// extracted by mini-css-extract-plugin
export default {"wrap":"references_wrap__Kym3Y"};